<template>
  <div class="ed-grid m-grid-2 lg-grid-4 s-to-center s-center">
    <section class="proyectospublicos__card">
      <h2 class="">Diseño UX</h2>
      <p class="proyectospublicos__parrafocard">
        Escoge el proyecto que más te guste, comienza a investigar, sigue los
        requerimientos y presenta los resultados.
      </p>
    </section>

    <section class="proyectospublicos__card">
      <h2 class="">Diseño UI</h2>
      <p class="proyectospublicos__parrafocard">
        Elije un proyecto de la comunidad UX, crea las interfaces siguiendo lo
        establecido y presenta.
      </p>
    </section>

    <section class="proyectospublicos__card">
      <h2 class="">Programación Frontend</h2>
      <p class="proyectospublicos__parrafocard">
        Elige dos proyectos (UI y Backend), contruye el fontend siguiedo el
        diseño y consume una API.
      </p>
    </section>

    <section class="proyectospublicos__card">
      <h2 class="">Programación Backend</h2>
      <p class="proyectospublicos__parrafocard">
        Programa APi's con conexión a base de datos y autenticación, el resto se
        encarga el que consuma tu trabajo.
      </p>
    </section>
  </div>
</template>
<style scoped lang="scss">
@import "../../sass/home.scss";
img {
  background: black;
  margin-top: 25px;
}


</style>